// extracted by mini-css-extract-plugin
module.exports = {"Alert":"TranslationForm_Alert__efBBO","ButtonBar":"TranslationForm_ButtonBar__2ePkO","Feedback":"TranslationForm_Feedback__s84_p"};